import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moneyDisplay',
  standalone: true,
})
export class MoneyDisplayPipe implements PipeTransform {
  transform(amount: number | null | undefined, currency: string | null | undefined): string {
    const safeAmount = Number(amount ?? 0);

    const symbol = this.getCurrencySymbol(currency);

    return `${symbol} ${safeAmount.toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  private getCurrencySymbol(currency: string | null | undefined): string {
    switch ((currency ?? '').toUpperCase()) {
      case 'ARS':
        return '$';
      case 'USD':
        return 'US$';
      case 'EUR':
        return '€';
      default:
        return '$';
    }
  }
}
